<!-- Preview Mode: Static element with exact same Spartan classes -->
@if (isPreview) {
<div
  [class]="tooltipClasses + ' tooltip-size'"
  [class.isPreview]="isPreview"
  style="display: inline-block; position: relative"
  [innerHTML]="content | safeHtml"
></div>
} @else {
<span
  #triggerElement
  #tooltipTrigger="brnTooltipTrigger"
  class="labelIdle icon-wrapper cursor-pointer"
  [brnTooltipTrigger]="tooltipContentTpl"
  [touchGestures]="'on'"
  [tooltipContentClasses]="tooltipClasses"
  (clickOutside)="handleClickOutside($event)"
  (click)="$event.preventDefault(); $event.stopPropagation(); tooltipTrigger.toggle()"
>
  <mat-icon [ngStyle]="infoIconStyles ? infoIconStyles : {}" [svgIcon]="icon"></mat-icon>
</span>
}

<ng-template #tooltipContentTpl>
  <div
    [finxonePlatformTooltipArrowPosition]="triggerElementRef?.nativeElement"
    [innerHTML]="content | safeHtml"
    class="tooltip-size"
  ></div>
</ng-template>
